import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, Container } from "react-bootstrap";
import { ModalDlgConfirm } from "../../components/common";
import { AccountFormRoler } from "../../components/account/AccountForm";
import { registerAccout } from "../../lib/api/account";

const AccountNew = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState({
    alias: "",
    name: "",
    password: "",
    password2: "",
    roler: "",
    dsUnivId: "",
    dsUnivPw: "",
    dsUnivLink: false,
  });
  const [validated, setValidated] = useState(false);
  const [authForm, setAuthForm] = useState({
    show: false,
    title: "",
  });

  const [dlgConfirm, setDlgConfirm] = useState({
    type: "",
    msg: "",
    show: false,
    handleClose: () => {
      setDlgConfirm({
        ...dlgConfirm,
        show: false,
      });
    },
  });

  const handleAlias = (e) => {
    setUser({ ...user, alias: e.target.value });
  };

  const handleName = (e) => {
    setUser({ ...user, name: e.target.value });
  };

  const handlePassword = (e) => {
    setUser({ ...user, password: e.target.value });
  };

  const handlePassword2 = (e) => {
    setUser({ ...user, password2: e.target.value });
  };

  const handleDSUnivId = (e) => {
    setUser({ ...user, dsUnivId: e.target.value });
  };

  const handleDSUnivPassword = (e) => {
    setUser({ ...user, dsUnivPw: e.target.value });
  };

  const handleDSUnivSubmit = (e) => {
    const dsUnivLink = !user.dsUnivLink;
    setAuthForm({ ...user, dsUnivLink });
    console.log("user : ", user);
  };

  const handleRoler = (e) => {
    const roler = e.target.value;
    const { show, name } =
      roler === "professor"
        ? { show: true, name: "교직원 번호" }
        : roler === "student"
        ? { show: true, name: "학번" }
        : { show: false, name: "" };

    setUser({ ...user, roler });
    setAuthForm({ ...authForm, show, name });
  };

  const handleSubmit = async (e) => {
    console.log("AccoutForm handleSubmit");

    const form = e.currentTarget;
    const resultValidity = form.checkValidity();
    setValidated(true);
    e.preventDefault();
    e.stopPropagation();

    if (!resultValidity) {
      console.log("AccoutForm resultValidity failed");
      return;
    }

    console.log("AccoutForm register");
    const { status, message } = await registerAccout({
      displayName: user.alias,
      username: user.name,
      password: user.password,
      password2: user.password2,
      roles: [user.roler], // 역활이 배열
      dsUnivLink: user.dsUnivLink,
    });

    setDlgConfirm({
      ...dlgConfirm,
      type: "info",
      msg: message,
      show: true,
    });
  };

  return (
    <div className="AccountNew">
      <Container fluid="md">
        <br />
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Form.Group controlId="userAlias">
            <Form.Label>사용자 별칭</Form.Label>
            <Form.Control
              onChange={handleAlias}
              type="text"
              placeholder="user alias"
              required
            />
            <Form.Control.Feedback type="invalid" className={"float-left"}>
              사용자 별칭을 입력해주세요!
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="userName">
            <Form.Label>사용자 아이디</Form.Label>
            <Form.Control
              onChange={handleName}
              type="text"
              placeholder="user name"
              required
            />
            <Form.Control.Feedback type="invalid" className={"float-left"}>
              사용자 아이디을 입력해주세요!
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="password">
            <Form.Label>비밀번호</Form.Label>
            <Form.Control
              onChange={handlePassword}
              type="password"
              placeholder="password"
              required
            />
            <Form.Control.Feedback type="invalid" className={"float-left"}>
              비밀번호를 입력해주세요!
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="confirm-password">
            <Form.Label>비밀번호 확인</Form.Label>
            <Form.Control
              onChange={handlePassword2}
              type="password"
              placeholder="confirm password"
              required
            />
            <Form.Control.Feedback type="invalid" className={"float-left"}>
              비밀번호를 입력해주세요!
            </Form.Control.Feedback>
          </Form.Group>

          <AccountFormRoler
            roler={user.roler}
            authForm={authForm}
            handleRoler={handleRoler}
            handleDSUnivId={handleDSUnivId}
            handleDSUnivPassword={handleDSUnivPassword}
            handleDSUnivSubmit={handleDSUnivSubmit}
          />

          <br />
          <Button className="btn-lg " variant="primary" type="submit">
            제출
          </Button>
        </Form>
      </Container>
      <ModalDlgConfirm
        show={dlgConfirm.show}
        handleClose={dlgConfirm.handleClose}
        type={dlgConfirm.type}
        msg={dlgConfirm.msg}
      />
    </div>
  );
};

export default AccountNew;
